import {addComponentKeysets} from '../../../i18n';

import en from './en.json';
import ru from './ru.json';

const COMPONENT = 'AvatarStack';

export default addComponentKeysets({en, ru}, COMPONENT);
